// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"e29f9af6","488":"d5bd5f35","563":"ed6da56f"}[chunkId] + ".chunk.js";
};